import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeAttachmentType } from "../Entity/TreeNodeAttachmentType";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { ErrorType } from "../../ErrorType";
import { Util } from "../../../Util";

export class TreeNodeAttachmentList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Attachments ({param})');
      this.parent = parent;
      this.labelNodeName = 'Attachments';
      this.expanded = true;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let node = new TreeNodeAttachmentType(this.ioc!, this);
      node.data.model.attachmenttype = params.nodeType;
      if ((params.operationType===1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) {
        node.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber();
      }
      node.data.model.filename =
        'Attachment' +
        this.ioc!.get(LookupGetService)
          .getFilenameNumber()
          .toString()
          .padStart(2, '0');
      this.children?.push(node);
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let attachments: any[] = [];
      this.children?.forEach((node) => {
        let attachment = node as TreeNodeAttachmentType;
        let art57Message = attachment.getMessage();
        if (art57Message != null) {
          attachments.push(art57Message);
        }
      });
  
      if (this.children!.length > 0) {
        return { attachments: { attachment: attachments } };
      } else {
        return;
      }
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Operation Type', 'Attachment Type', 'Attachment Name'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeAttachmentList = new TreeNodeAttachmentList(
        this.ioc!,
        newParent
      );
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)


      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      let errors: any = [];
      let acumulatedAttachmentSize = 0;
      this.children?.forEach((child:any)=>{
        acumulatedAttachmentSize = child.data.model.file?acumulatedAttachmentSize + child.data.model.file[0].size:acumulatedAttachmentSize;
       }
      );

      if (acumulatedAttachmentSize > environment.maxCumulativeByteSize){
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'Total of Attachments size exceed maximum size allowed: ' + Util.formatFileSize(environment.maxCumulativeByteSize, 0),
        });
      } else {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.errorInactive,
          controlId: undefined,
          controlLabel: '',
          error: '',
        });
      }      
    
      return errors;

    }
  }

  